import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Select } from 'antd';
import AustraliaStateType from '../enums/AustraliaStateType';
const StateSelect = ({ countryCode = "AU", value, placeholder = "State", disabled = false, onChange }) => {
    const options = useMemo(() => {
        switch (countryCode) {
            case 'AU':
                return AustraliaStateType.selectOptionsArray();
            case 'NZ':
                return [];
            default:
                return AustraliaStateType.selectOptionsArray();
        }
    }, [countryCode]);
    return (_jsx(Select, { value: value, onChange: onChange, placeholder: placeholder, disabled: disabled, showSearch: {
            optionFilterProp: ['filter']
        }, options: options }));
};
export default StateSelect;
